<template>
  <div>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />

    <b-row>
      <b-col>
        <h2>{{ $t("checklist.form.editing") }}</h2>
        <b-button @click="voltar()" size="sm">
          {{ $t("geral.back") }}
        </b-button>
      </b-col>
    </b-row>

    <b-row style="margin-top: 30px">
      <b-col lg="6" md="6" sm="6">
        <!-- OriginStateId -->
        <b-form-group
          :label="$t('tracking.cargo.originState')"
          label-for="OriginStateId"
        >
          <b-form-select
            id="OriginStateId"
            v-model="model.originStateId"
            :options="optionsState"
            :disabled="readonly"
          />
        </b-form-group>

        <!-- OriginCityId -->
        <b-form-group
          :label="$t('tracking.cargo.originCity')"
          label-for="OriginCityId"
        >
          <city-dropdown
            id="OriginCityId"
            :readonly="readonly"
            :state-id="parseInt(model.originStateId)"
            :city-id="model.originCityId"
            :changeData.sync="model.originCityId"
          />
          <span class="text-danger" v-if="modelstate['OriginCityId']">
            {{ modelstate["OriginCityId"][0] }}
          </span>
        </b-form-group>

        <!-- DestinationStateId -->
        <b-form-group
          :label="$t('tracking.cargo.destinationState')"
          label-for="DestinationStateId"
        >
          <b-form-select
            id="DestinationStateId"
            :options="optionsState"
            v-model="model.destinyStateId"
            :disabled="readonly"
          />
        </b-form-group>

        <!-- DestinationCityId -->
        <b-form-group
          :label="$t('tracking.cargo.destinationCity')"
          label-for="DestinationCityId"
        >
          <city-dropdown
            id="DestinationCityId"
            :readonly="readonly"
            :state-id="parseInt(model.destinyStateId)"
            :city-id="model.destinyCityId"
            :changeData.sync="model.destinyCityId"
          />
          <span class="text-danger" v-if="modelstate['DestinyCityId']">
            {{ modelstate["DestinyCityId"][0] }}
          </span>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="12" md="12" sm="12">
        <!-- AdditionalInfortion -->
        <b-form-group
          :label="$t('tracking.cargo.additionalInformation')"
          label-for="additionalInformation"
        >
          <b-form-textarea
            id="additionalInformation"
            :placeholder="$t('tracking.cargo.additionalInformation')"
            v-model="model.complement"
            :readonly="readonly"
          />
        </b-form-group>

        <b-button @click="savePath" size="sm" :disabled="submitted">
          {{ $t("geral.save") }}
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    CityDropdown: () => import("@/components_rms/System/city/CityDropdown.vue"),
  },
  props: {
    readonly: Boolean,
  },
  data() {
    return {
      modelstate: {},
      idRotogram: this.$route.params.id,
      alert: {
        error: "Erro",
        success: "Registro criado com sucesso",
      },

      optionsState: [{ value: null, text: "Carregando cidades" }],

      model: {
        originStateId: null,
        originCityId: null,
        destinyStateId: null,
        destinyCityId: null,
        complement: "",
      },
    };
  },
  created() {
    this.loadStates();
    this.getPath();
  },
  methods: {
    loadStates() {
      this.$api
        .get("/state/getDropdownOptions")
        .then((response) => {
          this.optionsState = response.data;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    getPath() {
      this.$api
        .get(`/rotograma/${this.idRotogram}`)
        .then((response) => {
          this.model = response.data;
        })
        .catch((error) => {
          console.log(error.response);
        });
    },
    savePath() {
      this.modelstate = {};
      this.$api
        .put(`/rotograma/edit/${this.idRotogram}`, this.model)
        .then((response) => {
          if (response.data.status == 500) {
            this.alert.error = response.data.title;
            this.$refs.fadeAlertDanger.show();
          } else {
            this.$refs.alert.show();
            this.$router.push("/trackingShippingCompany/cargo/rotogram");
          }
        })
        .catch((error) => {
          if (error.response.status == 400) {
            this.modelstate = error.response.data.errors;
          }
        });
    },
    voltar() {
      this.$router.go(-1);
    },
  },
};
</script>
   